import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CurrencyRow from './CurrencyRow';
import { currenciesType, sortingParamType } from '../../types';
import './_styles_/CurrenciesList.css';
import SortControl from '../SortControl';

CurrenciesList.propTypes = {
    currencies: currenciesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function CurrenciesList(props) {
    const {
        currencies,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="currencies-list">
            <div className="rich-list-row rich-list-header currencies-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="currency-header--values--code">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="code">
                        {t('currencies.list-header.code')}
                    </SortControl>
                </div>
                <div className="currency-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('currencies.list-header.name')}
                    </SortControl>
                </div>
                <div className="currency-header--values--exchange-rate">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="exchangeRate">
                        {t('currencies.list-header.exchange-rate')}
                    </SortControl>
                </div>
                <div className="currency-header--values--active">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="active">
                        {t('currencies.list-header.active')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {currencies.map((currency) => <CurrencyRow currency={currency} key={currency.code} />)}
        </div>
    );
}

export default CurrenciesList;
